import { memo } from 'react';

import { Box } from '@material-ui/core';
import { RejectButton, ApplyButton, Loader } from 'components';

import { useStyles } from './style';

interface Props {
  upload: boolean;
  apply: () => void;
  reject: () => void;
}

const ConfirmationDialogDetails = ({ upload, apply, reject }: Props) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <p className={classes.title}>
        Haluatko, että Tervetuloa-ikkuna aukeaa, kun seuraavalla kerralla
        kirjaudut portaaliin?
      </p>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="flex-end"
        width="100%"
        marginTop={2}
      >
        <RejectButton
          onClick={apply}
          disabled={upload}
          className={classes.rejectBtn}
        >
          Ei
          {upload ? (
            <Box display="block" marginLeft="10px">
              <Loader
                cls={{
                  root: classes.loader,
                }}
                size={17}
              />
            </Box>
          ) : null}
        </RejectButton>
        <ApplyButton onClick={reject} disabled={upload}>
          Kyllä
        </ApplyButton>
      </Box>
    </Box>
  );
};

export default memo(ConfirmationDialogDetails);
